"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var NextStepButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(NextStepButton, _PureComponent);

  function NextStepButton() {
    (0, _classCallCheck2.default)(this, NextStepButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(NextStepButton).apply(this, arguments));
  }

  (0, _createClass2.default)(NextStepButton, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.secondaryNavigation." + suffix;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;
      return _react.default.createElement(_UIButton.default, {
        disabled: disabled,
        onClick: onClick,
        use: "primary"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('next')
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        disabled: _react.PropTypes.bool,
        onClick: _react.PropTypes.func.isRequired
      };
    }
  }]);
  return NextStepButton;
}(_react.PureComponent);

exports.default = NextStepButton;
module.exports = exports.default;